/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ArchivedReportFlowContainer_comment = {
    readonly id: string;
    readonly story: {
        readonly url: string;
    };
    readonly " $refType": "ArchivedReportFlowContainer_comment";
};
export type ArchivedReportFlowContainer_comment$data = ArchivedReportFlowContainer_comment;
export type ArchivedReportFlowContainer_comment$key = {
    readonly " $data"?: ArchivedReportFlowContainer_comment$data;
    readonly " $fragmentRefs": FragmentRefs<"ArchivedReportFlowContainer_comment">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ArchivedReportFlowContainer_comment",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "concreteType": "Story",
            "kind": "LinkedField",
            "name": "story",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "url",
                    "storageKey": null
                }
            ],
            "storageKey": null
        }
    ],
    "type": "Comment",
    "abstractKey": null
} as any);
(node as any).hash = 'db8cfce556e202f032ef10e6d3947594';
export default node;
